import {
  FETCH_GLOBAL_PROJECT_NAME_REQUEST,
  FETCH_GLOBAL_PROJECT_NAME_SUCCESS,
  FETCH_GLOBAL_PROJECT_NAME_FALUIRE,
} from './globalProjectNameSelectionTypes'

const initialState = {
  loading: false,
  globalSelectedProjectName: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_GLOBAL_PROJECT_NAME_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_GLOBAL_PROJECT_NAME_SUCCESS : return {
      ...state,
      globalSelectedProjectName: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_GLOBAL_PROJECT_NAME_FALUIRE : return {
      ...state,
      loading: false,
      globalSelectedProjectName: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
